import React from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { handleLogout } from '../../redux/actions';
import { Person, Lock, Ticket, Discount, Brilliant, Logout } from '../../utils';

import { UserList, UserItem, Icon, LogoutButton } from './styles';

const UserNavigation = ({ isInNavigation, handleLogoutClick }) => (
  <UserList isInNavigation={isInNavigation}>
    <UserItem>
      <Link href="/my-account">
        <a>
          <Icon>
            <Person />
          </Icon>
          Account
        </a>
      </Link>
    </UserItem>
    <UserItem>
      <Link href="/my-password">
        <a>
          <Icon>
            <Lock />
          </Icon>
          Password
        </a>
      </Link>
    </UserItem>
    <UserItem>
      <Link href="/my-bookings">
        <a>
          <Icon>
            <Ticket />
          </Icon>
          Bookings
        </a>
      </Link>
    </UserItem>
    <UserItem>
      <Link href="/my-credits">
        <a>
          <Icon>
            <Discount />
          </Icon>
          DayAxe Credits
        </a>
      </Link>
    </UserItem>
    <UserItem>
      <Link href="/my-membership">
        <a>
          <Icon>
            <Brilliant />
          </Icon>
          Membership
        </a>
      </Link>
    </UserItem>
    <UserItem>
      <LogoutButton onClick={handleLogoutClick}>
        <Icon>
          <Logout />
        </Icon>
        Logout
      </LogoutButton>
    </UserItem>
  </UserList>
);

UserNavigation.propTypes = {
  isInNavigation: PropTypes.bool,
  handleLogoutClick: PropTypes.func,
};

const mapDispatchToProps = dispatch => bindActionCreators({
  handleLogoutClick: handleLogout,
}, dispatch);

export default connect(null, mapDispatchToProps)(UserNavigation);
